<template>
  <q-card class="dash-number-box bg-white">
    <q-card-main>
      <div class="row gutter-x-md">
        <div class="col-auto">
          <q-icon name="timer" class="circle bg-red-1 text-red-5 q-pa-sm q-mt-xs" style="font-size: 1.75rem;"/>
        </div>
        <div class="col">
          <span class="dash-number-box__value--small">{{ formatMoney(amount, currency, 0, 0) }}</span>
          <h2 class="dash-number-box__heading--small">{{ $tc('statistics_overdue_invoices', number, { number }) }}</h2>
        </div>
      </div>
    </q-card-main>
  </q-card>
</template>

<script>
  import { formatMoney } from 'src/utils/format'

  export default {
    props: {
      amount: {
        type: Number,
        required: true
      },
      number: {
        type: Number,
        required: true
      },
      currency: {
        type: String,
        required: true
      }
    },
    methods: {
      formatMoney: formatMoney
    }
  }
</script>
